export const enum BookingRoutes {
  baggage = 'BAGGAGE',
  challenge = 'challenge',
  confirmation = 'confirmation',
  contactInfo = 'contact-info',
  dangerousGoods = 'dangerous-goods',
  findMoreFlights = 'find-more-flights',
  payment = 'payment',
  recovery = 'recovery',
  seatmap = 'seatmap',
  services = 'services',
  shoppingCart = 'shopping-cart',
  traveler = 'traveler',
  upsell = 'availability',
  upsellComplexFlow = 'availability-complex',
  timetable = 'timetable',
  flightStatusSearch = 'flight-status/search',
  flightStatusRecap = 'flight-status',
  carRentalInApp = 'cars',
  insurance = 'insurance'
}

export const enum ManageBookingRoutes {
  confirmation = 'manage-booking/confirmation',
  insurance = 'manage-booking/insurance',
  retrieve = 'manage-booking/retrieve',
  retrieveExpiredBooking = 'manage-booking/retrieveExpiredBooking',
  reviewUnpaidServices = 'manage-booking/reviewUnpaidServices',
  traveler = 'manage-booking/traveler',
  blueRibbonBags = 'manage-booking/blueRibbonBags',
  flightsUpgrade = 'manage-booking/flightUpgrade'
}

export const enum RebookingRoutes {
  confirmation = 'rebooking/confirmation',
  payment = 'rebooking/payment',
  recap = 'rebooking/recap',
  search = 'rebooking/search',
  upsell = 'rebooking/availability',
  traveler = 'rebooking/traveler'
}

export const enum RewardRoutes {
  retrieve = 'reward/manage-booking/retrieve',
  upsell = 'reward/availability'
}

export const enum BookingRouteParams {
  boundIndex = 'boundIndex',
  flightId = 'flightId',
  serviceCode = 'serviceCode',
  travelerId = 'travelerId',
  travelerIndex = 'travelerIndex'
}

export const enum RebookingRouteParams {
  boundIndex = 'boundIndex'
}

export const enum RoutesTitle {
  baggage = 'refx-title.baggage',
  challenge = 'refx-title.challenge',
  confirmation = 'refx-title.confirmation',
  contactInfo = 'refx-title.contactInformation',
  dangerousGoods = 'refx-title.dangerous-goods',
  findMoreFlights = 'refx-title.findMoreFlights',
  insurance = 'refx-title.insurance',
  manageBooking = 'refx-title.manageBooking',
  pack = ' refx-title.pack',
  seat_pack = 'refx-title.pack_seat',
  payment = 'refx-title.payment',
  rebookingConfirmation = 'refx-title.rebookingConfirmation',
  rebookingPayment = 'refx-title.rebookingPayment',
  rebookingRecap = 'refx-title.rebookingRecap',
  rebookingSearch = 'refx-title.rebookingSearch',
  rebookingUpsell = 'refx-title.rebookingUpsell',
  recovery = 'refx-title.recovery',
  retrieve = 'refx-title.retrieve',
  retrieveExpiredBooking = 'refx-title.retrieveExpiredBooking',
  reviewUnpaidServices = 'refx-title.reviewUnpaidServices',
  rewardRetrieve = 'refx-title.rewardRetrieve',
  rewardUpsell = 'refx-title.rewardUpsell',
  seatmap = 'refx-title.seatmap',
  services = 'refx-title.services',
  shoppingCart = 'refx-title.shoppingCart',
  traveler = 'refx-title.traveler',
  updateContactInfo = 'refx-title.updateContactInformation',
  updateTraveler = 'refx-title.updateTraveler',
  upsell = 'refx-title.upsell',
  upsellComplexFlow = 'refx-title.upsell-complex-flow',
  timetable = 'refx-title.timetable',
  carRentalInApp = 'refx-title.carRentalInApp',
  flightStatusSearch = 'refx-title.flight-status-search',
  flightStatusRecap = 'refx-title.flight-status-recap',
  blueRibbonBags = 'refx-title.blueRibbonBags',
  flightsUpgrade = 'refx-title.flights-upgrade-page'
}

export const enum BookingPageId {
  baggage = 'BAGGAGE',
  challenge = 'CHALLENGE',
  confirmation = 'CONFIRMATION',
  contactInfo = 'CONTACTINFO',
  dangerousGoods = 'DANGEROUSGOODS',
  findMoreFlights = 'FINDMOREFLIGHTS',
  insurance = 'INSURANCE',
  manageBooking = 'MANAGEBOOKING',
  payment = 'PAYMENT',
  rebookingConfirmation = 'REBOOKINGCONFIRMATION',
  rebookingPayment = 'REBOOKINGPAYMENT',
  rebookingRecap = 'REBOOKINGRECAP',
  rebookingSearch = 'REBOOKINGSEARCH',
  rebookingUpsell = 'REBOOKINGUPSELL',
  recovery = 'RECOVERY',
  retrieve = 'RETRIEVE',
  retrieveExpiredBooking = 'RETRIEVEEXPIREDBOOKING',
  seatmap = 'SEATMAP',
  services = 'SERVICES',
  shoppingCart = 'SHOPPINGCART',
  reviewUnpaidServices = 'REVIEWUNPAIDSERVICES',
  traveler = 'TRAVELER',
  updateContactInfo = 'UPDATECONTACTINFO',
  upsell = 'UPSELL',
  upsellComplexFlow = 'UPSELLCOMPLEXFLOW',
  overview = 'OVERVIEW',
  ascConfirmation = 'ASCCONFIRMATION',
  timetable = 'TIMETABLE',
  flightStatusSearch = 'FLIGHTSTATUSSEARCH',
  flightStatusRecap = 'FLIGHTSTATUSRECAP',
  blueRibbonBags = 'BLUERIBBONBAGS',
  flightsUpgrade = 'FLIGHTSUPGRADEPAGE',
  carRentalInApp = 'CARRENTALINAPP'
}

export const enum RewardPageId {
  retrieve = 'REWARDRETRIEVE',
  upsell = 'REWARDUPSELL'
}

export const pageDetails: {[page in BookingPageId | RewardPageId]: {titleKey: RoutesTitle;
  description: string;
  name: BookingRoutes | ManageBookingRoutes | RebookingRoutes | RewardRoutes;}} = {
  [BookingPageId.baggage]: {
    titleKey: RoutesTitle.baggage,
    description: 'Baggage Page',
    name: BookingRoutes.baggage
  },
  [BookingPageId.challenge]: {
    titleKey: RoutesTitle.challenge,
    description: 'Challenge Page',
    name: BookingRoutes.challenge
  },
  [BookingPageId.confirmation]: {
    titleKey: RoutesTitle.confirmation,
    description: 'Confirmation Page',
    name: BookingRoutes.confirmation
  },
  [BookingPageId.overview]: {
    titleKey: RoutesTitle.confirmation,
    description: 'Confirmation Page',
    name: BookingRoutes.confirmation
  },
  [BookingPageId.ascConfirmation]: {
    titleKey: RoutesTitle.confirmation,
    description: 'Confirmation Page',
    name: BookingRoutes.confirmation
  },
  [BookingPageId.contactInfo]: {
    titleKey: RoutesTitle.contactInfo,
    description: 'Contact Information Page',
    name: BookingRoutes.contactInfo
  },
  [BookingPageId.dangerousGoods]: {
    titleKey: RoutesTitle.dangerousGoods,
    description: 'Dangerous Goods Page',
    name: BookingRoutes.dangerousGoods
  },
  [BookingPageId.findMoreFlights]: {
    titleKey: RoutesTitle.findMoreFlights,
    description: 'Find more flights Page',
    name: BookingRoutes.findMoreFlights
  },
  [BookingPageId.insurance]: {
    titleKey: RoutesTitle.insurance,
    description: 'Insurance Page',
    name: ManageBookingRoutes.insurance
  },
  [BookingPageId.manageBooking]: {
    titleKey: RoutesTitle.manageBooking,
    description: 'Manage Booking Page',
    name: ManageBookingRoutes.retrieve
  },
  [BookingPageId.payment]: {
    titleKey: RoutesTitle.payment,
    description: 'Payment Page',
    name: BookingRoutes.payment
  },
  [BookingPageId.rebookingConfirmation]: {
    titleKey: RoutesTitle.rebookingConfirmation,
    description: 'Rebooking confirmation Page',
    name: RebookingRoutes.confirmation
  },
  [BookingPageId.rebookingPayment]: {
    titleKey: RoutesTitle.rebookingPayment,
    description: 'Rebooking payment Page',
    name: RebookingRoutes.payment
  },
  [BookingPageId.rebookingRecap]: {
    titleKey: RoutesTitle.rebookingRecap,
    description: 'Rebooking recap Page',
    name: RebookingRoutes.recap
  },
  [BookingPageId.rebookingSearch]: {
    titleKey: RoutesTitle.rebookingSearch,
    description: 'Rebooking search Page',
    name: RebookingRoutes.search
  },
  [BookingPageId.rebookingUpsell]: {
    titleKey: RoutesTitle.rebookingUpsell,
    description: 'Rebooking upsell Page',
    name: RebookingRoutes.upsell
  },
  [BookingPageId.recovery]: {
    titleKey: RoutesTitle.recovery,
    description: 'Recovery Page',
    name: BookingRoutes.recovery
  },
  [BookingPageId.retrieve]: {
    titleKey: RoutesTitle.retrieve,
    description: 'Retrieve Page',
    name: ManageBookingRoutes.retrieve
  },
  [BookingPageId.retrieveExpiredBooking]: {
    titleKey: RoutesTitle.retrieveExpiredBooking,
    description: 'Retieve Expired Page',
    name: ManageBookingRoutes.retrieveExpiredBooking
  },
  [BookingPageId.reviewUnpaidServices]: {
    titleKey: RoutesTitle.reviewUnpaidServices,
    description: 'Review Unpaid Services Page',
    name: ManageBookingRoutes.reviewUnpaidServices
  },
  [BookingPageId.seatmap]: {
    titleKey: RoutesTitle.seatmap,
    description: 'Seatmap Page',
    name: BookingRoutes.seatmap
  },
  [BookingPageId.services]: {
    titleKey: RoutesTitle.services,
    description: 'Services Page',
    name: BookingRoutes.services
  },
  [BookingPageId.shoppingCart]: {
    titleKey: RoutesTitle.shoppingCart,
    description: 'Shopping Cart Page',
    name: BookingRoutes.shoppingCart
  },
  [BookingPageId.traveler]: {
    titleKey: RoutesTitle.traveler,
    description: 'Traveler Page',
    name: BookingRoutes.traveler
  },
  [BookingPageId.updateContactInfo]: {
    titleKey: RoutesTitle.updateContactInfo,
    description: 'Update Contact Information Page',
    name: BookingRoutes.contactInfo
  },
  [BookingPageId.upsell]: {
    titleKey: RoutesTitle.upsell,
    description: 'Availability Page',
    name: BookingRoutes.upsell
  },
  [BookingPageId.upsellComplexFlow]: {
    titleKey: RoutesTitle.upsell,
    description: 'Availability Complex Page',
    name: BookingRoutes.upsellComplexFlow
  },
  [RewardPageId.retrieve]: {
    titleKey: RoutesTitle.rewardRetrieve,
    description: 'Reward Retrieve Page',
    name: RewardRoutes.retrieve
  },
  [RewardPageId.upsell]: {
    titleKey: RoutesTitle.rewardUpsell,
    description: 'Reward Upsell Page',
    name: RewardRoutes.upsell
  },
  [BookingPageId.timetable]: {
    titleKey: RoutesTitle.timetable,
    description: 'Timetable Page',
    name: BookingRoutes.timetable
  },
  [BookingPageId.flightStatusSearch]: {
    titleKey: RoutesTitle.flightStatusSearch,
    description: 'Flight status search Page',
    name: BookingRoutes.flightStatusSearch
  },
  [BookingPageId.flightStatusRecap]: {
    titleKey: RoutesTitle.flightStatusRecap,
    description: 'Flight Status Recap Page',
    name: BookingRoutes.flightStatusRecap
  },
  [BookingPageId.blueRibbonBags]: {
    titleKey: RoutesTitle.blueRibbonBags,
    description: 'Blue Ribbon Bags Page',
    name: ManageBookingRoutes.blueRibbonBags
  },
  [BookingPageId.flightsUpgrade]: {
    titleKey: RoutesTitle.flightsUpgrade,
    description: 'Flights upgrade page',
    name: ManageBookingRoutes.flightsUpgrade
  },
  [BookingPageId.carRentalInApp]: {
    titleKey: RoutesTitle.carRentalInApp,
    description: 'Car Rental In App Page',
    name: BookingRoutes.carRentalInApp
  }
};

/** Enum for all the routes in the application */
export type AppRoutes = BookingRoutes | ManageBookingRoutes | RebookingRoutes | RewardRoutes;

/**
 * The routes for which the skeleton loader should be displayed
 */
export const skeletalRoutes: AppRoutes[] = [
  BookingRoutes.upsell,
  BookingRoutes.shoppingCart,
  ManageBookingRoutes.confirmation,
  ManageBookingRoutes.retrieve,
  BookingRoutes.confirmation,
  BookingRoutes.timetable
];
